"use strict";

import * as googleMap from "@elements/google-map/index";
import {on, addClass, removeClass, closest, findIn } from "@elements/dom-utils"
import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from '@elements/data-set-utils'

export function init() {
    onFind('.js-location-teaser-map', function (item) {

        let overlayToggle = findIn('.js-location-teaser-map__overlay-toggle', item);
        let locationMap = findIn('.js-location-teaser-map__map', item);
        let map = findIn('.js-google-map', item);
        let infoBox = findIn('.js-location-teaser__infobox', item);
        let dataSet = getPrefixedDataSet('location-teaser', item);

        on('click', function (evt) {
            let overlay = closest('.js-location-teaser-map__overlay', evt.target);

            addClass('d-none', overlay);
            removeClass('d-none', locationMap);

            googleMap.createGoogleMap(map,{
                poiStyles: () => createPoiStyles(),
                onActivateMarker: (marker, api) => api.showInfoBoxByMarker(marker, infoBox.innerHTML),
                onDeactivateMarker: (marker, api) => api.closeInfoBoxByMarker(marker),
                mapOptions: {
                    zoom: 10,
                    scrollwheel: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                }
            }).then(api => {
                console.log('map initialized!');
            });

            googleMap.getApi(map).then((map) => {
                map.setMarker([{
                    id: '0',
                    lat: dataSet.lat,
                    lng: dataSet.lng,
                }])
                map.centerMap();
            });

            function createPoiStyles(){
                return {
                    default: {
                        default: {
                            url: '/static/img/map/pin.svg',
                            size: new google.maps.Size(34, 50),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(25, 45),
                            scaledSize: new google.maps.Size(34, 50)
                        },
                        active: {
                            url: '/static/img/map/pin.svg',
                            size: new google.maps.Size(34, 50),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(25, 45),
                            scaledSize: new google.maps.Size(34, 50)
                        }
                    }
                };
            }

        }, overlayToggle);
    });
}


